export default function generateBotTestPage({ title, logo, botEmbedCode }) {
  return `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
    <title>${title}</title>
    <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap" rel="stylesheet" />
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }
        html, body {
            height: 100%;
            font-family: "Poppins", sans-serif;
            color: #1a1a1a;
        }
        header {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            background-color: #fff;
            box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
            z-index: 999;
        }
        .navbar {
            max-width: 1200px;
            margin: 0 auto;
            padding: 15px 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .logo {
            font-weight: 700;
            font-size: 1.4rem;
            color: #4c3fcf;
            text-decoration: none;
        }
        .nav-links {
            display: flex;
            align-items: center;
            gap: 30px;
        }
        .nav-links a {
            text-decoration: none;
            color: #1a1a1a;
            font-weight: 500;
            transition: color 0.3s ease;
        }
        .nav-links a:hover {
            color: #4c3fcf;
        }
        .demo-btn {
            background-color: #41d195;
            color: #fff;
            padding: 10px 20px;
            border-radius: 6px;
            font-weight: 600;
            text-decoration: none;
            transition: background-color 0.3s ease, transform 0.3s ease;
        }
        .demo-btn:hover {
            background-color: #34b686;
            transform: translateY(-2px);
        }
        .hero {
            margin-top: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            max-width: 1200px;
            margin-left: auto;
            margin-right: auto;
            padding: 40px 20px;
            min-height: calc(100vh - 80px);
            position: relative;
            overflow: visible;
            z-index: 1;
        }
        .background-wave {
            position: absolute;
            top: 134px;
            left: 0;
            width: 100%;
            z-index: -1;
            transform: translate3d(0, 0, 0);
        }
        .hero-left {
            flex: 1 1 500px;
            max-width: 600px;
            padding: 20px;
        }
        .hero-left h1 {
            font-size: 2.5rem;
            font-weight: 700;
            margin-bottom: 20px;
            color: #2f2e8b;
            line-height: 1.2;
        }
        .hero-left p {
            font-size: 1.1rem;
            margin-bottom: 30px;
            line-height: 1.6;
            max-width: 500px;
        }
        .cta-buttons {
            display: flex;
            gap: 15px;
            flex-wrap: wrap;
        }
        .cta-buttons .view-demo {
            background-color: #4c3fcf;
            color: #fff;
            padding: 12px 24px;
            border-radius: 6px;
            border: none;
            font-size: 1rem;
            font-weight: 600;
            cursor: pointer;
            transition: background-color 0.3s ease, transform 0.3s ease;
        }
        .cta-buttons .view-demo:hover {
            background-color: #3a2fad;
            transform: translateY(-2px);
        }
        .hero-right {
            flex: 1 1 400px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 20px;
            position: relative;
            max-width: 600px;
        }
        .hero-right img {
            max-width: 100%;
            height: auto;
            display: block;
        }
        @media (max-width: 1024px) {
            .hero-left h1 {
                font-size: 2rem;
            }
            .hero-left p {
                font-size: 1rem;
            }
        }
        @media (max-width: 768px) {
            .hero {
                flex-direction: column;
                text-align: center;
            }
            .hero-left,
            .hero-right {
                max-width: 100%;
            }
            .hero-right {
                margin-top: 20px;
            }
        }
        footer {
            text-align: center;
            padding: 20px;
            font-size: 0.9rem;
            color: #777;
        }
        .sub-link {
            display: inline-block;
            background-color: #ffffff22;
            color: #ffd700;
            padding: 10px 20px;
            border-radius: 6px;
            text-decoration: none;
            font-weight: 600;
            transition: background-color 0.3s ease, color 0.3s ease;
        }
        .sub-link:hover {
            background-color: #ffffff44;
            color: #41b97e;
        }
    </style>
</head>
<body>
<header>
    <div class="navbar">
        <img src="${logo}" alt="Logo" height="100" style="padding: 4px;">
        <h2>${title}</h2>
    </div>
</header>
<section class="hero">
    <div class="hero-left">
        <h1>${title}</h1>
        <p>
            Use Clear Conversation button to start a new conversation with a different visitor.<br>
            Use <strong>👍</strong> and <strong>👎</strong> to provide feedback.
        </p>
        <div class="cta-buttons">
            <a class="sub-link" href="https://crescendocx.ai" target="_blank">CrescendoCX.AI Bot</a>
            <button id="clearConv" class="view-demo">Clear Conversation</button>
        </div>
    </div>
    <div class="hero-right">
        <img src="https://cdn.prod.website-files.com/670eeaaebe3a8ce79444ac48/6761eb5b68f6220834a83cf6_Crescendo%20AI%20Conductor.svg" loading="lazy" alt="Illustration" class="hero_img" data-cmp-ab="2" data-cmp-info="10">
    </div>
</section>
<img src="https://cdn.prod.website-files.com/670eeaaebe3a8ce79444ac48/6765fdbff370a261cf188dc8_Crescendo%20AI%20-%20Wave%20Background.svg" loading="lazy" alt="Background Wave" class="background-wave" data-cmp-ab="2" data-cmp-info="10" style="opacity: 1; transform: translate3d(0, 0, 0) scale3d(1, 1, 1); transform-style: preserve-3d;">
<footer>
    &copy; 2025 Crescendo. All rights reserved.
</footer>

${botEmbedCode}

<script>
    window.addEventListener('load', () => {
        const chatBot = document.querySelector('enegelai-bot');
        const clearConvBtn = document.querySelector('#clearConv');
        clearConvBtn.addEventListener('click', (e) => {
            console.log('Clear conv clicked!');
            chatBot.clearConversation();
        });
    });
</script>
</body>
</html>
  `;
}
